<div class="pwd">
  <label class="st-field-label">{{ label }}</label>
  <input [id]="idVal" class="form-control st-input-text-field" [placeholder]="placeHolderVal" type="password"
         [ngStyle]="{
            'width': width
         }"
         [value]="inputVal"
         [required]="requiredVal"
         [maxLength]="50"
  >
  <span class="p-viewer">
            <i *ngIf="textVisible" (click)="toggle()" class="bi bi-eye" aria-hidden="true"></i>
            <i *ngIf="!textVisible" (click)="toggle()" class="bi bi-eye-slash" aria-hidden="true"></i>
  </span>
</div>
